import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _this = this;
var __jsx = React.createElement;
import { faFilterList, faMagnifyingGlass } from "@fortawesome/pro-regular-svg-icons";
import AwesomeIcon from "../AwesomeIcon";
import classNames from "classnames";
import _ from "lodash";
import React, { useCallback, useEffect, useState } from "react";
var DebounceInput = function DebounceInput(props) {
  var _classNames2;
  var value = props.value,
    onChange = props.onChange,
    placeholder = props.placeholder,
    _props$className = props.className,
    className = _props$className === void 0 ? "" : _props$className,
    _props$inputClassName = props.inputClassName,
    inputClassName = _props$inputClassName === void 0 ? "" : _props$inputClassName,
    hasFilters = props.hasFilters,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    setShowFilters = props.setShowFilters,
    isPrimary = props.isPrimary;
  var _useState = useState(""),
    text = _useState[0],
    setText = _useState[1];
  useEffect(function () {
    if (value != text) {
      setText(value);
    }
  }, [value]);
  var debounce = function debounce(func) {
    var timer;
    return function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      var context = _this;
      if (timer) clearTimeout(timer);
      timer = setTimeout(function () {
        timer = null;
        func.apply(context, args);
      }, 500);
    };
  };
  var handleChange = function handleChange(val) {
    setText(val);
    optimizedFn(val);
  };
  var optimizedFn = useCallback(debounce(function (val) {
    onChange ? onChange(val) : null;
  }), []);
  return /*#__PURE__*/React.createElement("label", {
    className: classNames("relative text-gray-500 dark:text-gray-400 block w-full", _defineProperty({}, className, !!className))
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faMagnifyingGlass,
    size: "lg",
    className: classNames("w-6 absolute top-1/2 transform -translate-y-1/2 left-3 cursor-pointer text-teal-500 dark:text-gray-100", {
      "dark:text-teal-400": isPrimary
    })
  }), /*#__PURE__*/React.createElement("input", {
    value: text,
    className: classNames("form-input w-full p-3 pl-8 pr-8 bg-gray-200 dark:bg-gray-800 rounded-md border-transparent focus:border-transparent text-md", (_classNames2 = {
      " !border-teal-300": !_.isEmpty(text)
    }, _defineProperty(_classNames2, inputClassName, !!inputClassName), _defineProperty(_classNames2, "!border-teal-500 dark:!border-teal-300", !_.isEmpty(text) && !!inputClassName), _classNames2)),
    placeholder: placeholder,
    title: placeholder,
    onChange: function onChange(e) {
      return handleChange(e.target.value);
    },
    disabled: disabled
  }), hasFilters && /*#__PURE__*/React.createElement("div", {
    className: "text-teal-500 dark:text-gray-400 w-6 h-6 absolute top-1/2 transform -translate-y-1/2 right-3 cursor-pointer",
    onClick: function onClick() {
      setShowFilters ? setShowFilters() : null;
    }
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faFilterList,
    size: "lg",
    className: "text-teal-500 dark:text-teal-400"
  })));
};
export default DebounceInput;